import React from 'react'
import styled from "styled-components"
import { Controller } from 'react-hook-form'

import { FieldWrapper, validationRules } from '..'
import { DateInputFieldProps, MultiDateInputFieldProps } from './DateTimeInputField.types'
import { DateTimeInput } from '../../../ui-elements/DateTimeInput'
import { MultiDateInput } from '../../../ui-elements/MultiDateInput'
import { MultiDateInputFieldValue } from '../../../ui-elements/MultiDateInput/MultiDateInput.types'

import { styleTheme } from "../../../../style/theme";

export const DateTimeInputField: React.FC<DateInputFieldProps> = (props) => (
  <StyledDateTimeComponent {...props} />
)

type ComponentProps = Omit<DateInputFieldProps, 'register'> & {
  className?: string
}

type MultiComponentProps = Omit<MultiDateInputFieldProps, 'register'> & {
  className?: string
}

const DateTimeComponent: React.FC<ComponentProps> = (props) => (
  <FieldWrapper
    label={props.label}
    error={props.error}
    isRequired={props.required}
    column={props.column}
    labelClassName={props.labelClassName}
    fieldClassName={props.fieldClassName}
  >
    <Controller
      {...props}
      render={({ field }) => (
        <DateTimeInput
          {...field}
          showTimeSelect={true}
          showMonthYearPicker={false}
          selected={field.value}
          includeDates={props.dateOptions}
          className={`${props.className} datetime-input ${props.error ? 'error' : ''}`}
        />
      )}
      rules={{ required: props.required && validationRules.requiredSelect(props.label) }}
    />
  </FieldWrapper>
)

const StyledDateTimeComponent = styled(DateTimeComponent)`
  &.datetime-input {
    &.error {
      border: 1px solid ${styleTheme.colors.pink.base};
    }
  }
`

export const DateInputField: React.FC<DateInputFieldProps> = (props) => (
  <StyledDateComponent {...props} />
)

const DateComponent: React.FC<ComponentProps> = (props) => (
  <FieldWrapper
    label={props.label}
    error={props.error}
    isRequired={props.required}
    column={props.column}
    labelClassName={props.labelClassName}
    fieldClassName={props.fieldClassName}
  >
    <Controller
      {...props}
      render={({ field }) => (
          <DateTimeInput
            {...field}
            readonly={props.readonly}
            showTimeSelect={false}
            showMonthYearPicker={false}
            selected={field.value}
            openToDate={props.openToDate}
            includeDates={props.dateOptions}
            className={`${props.className} datetime-input ${props.error ? 'error' : ''}`}
            placeholder={props.placeholder || '日付を選択'}
          />
        )}
      rules={{ required: props.required && validationRules.requiredSelect(props.label) }}
    />
  </FieldWrapper>
)

const StyledDateComponent = styled(DateComponent)`
  &.datetime-input {
    &.error {
      border: 1px solid ${styleTheme.colors.pink.base};
    }
  }
`;

export const MultiDateInputField: React.FC<MultiDateInputFieldProps> = (props) => (
  <StyledMultiDateComponent {...props} />
);

const MultiDateComponent: React.FC<MultiComponentProps> = (props) => (
  <FieldWrapper
    label={props.label}
    error={props.error}
    isRequired={props.required}
    column={props.column}
    labelClassName={props.labelClassName}
    fieldClassName={props.fieldClassName}
  >
    <Controller
      {...props}
      render={({ field }) => {
        const fieldValue: MultiDateInputFieldValue = {
          dates: field.value.dates || [],
          weekday: field.value.weekday || false,
          holiday: field.value.holiday || false,
        };
        return (
          <MultiDateInput
            {...field}
            placeholder={props.placeholder || "日時"}
            onChange={field.onChange}
            selected={fieldValue}
            includeDates={props.includeDates}
            className={`${props.className} datetime-input ${
              props.error ? "error" : ""
            }`}
          />
        );
      }}
      rules={{
        required: props.required && validationRules.requiredSelect(props.label),
      }}
    />
  </FieldWrapper>
);

const StyledMultiDateComponent = styled(MultiDateComponent)`
  &.datetime-input {
    &.error {
      border: 1px solid ${styleTheme.colors.pink.base};
    }
  }
`;

export const MonthInputField: React.FC<DateInputFieldProps> = (props) => (
  <StyledMonthComponent {...props} />
)

const MonthComponent: React.FC<ComponentProps> = (props) => (
  <FieldWrapper
    label={props.label}
    error={props.error}
    isRequired={props.required}
    column={props.column}
    labelClassName={props.labelClassName}
    fieldClassName={props.fieldClassName}
  >
    <Controller
      {...props}
      render={({ field }) => (
        <DateTimeInput
          {...field}
          showTimeSelect={false}
          showMonthYearPicker={true}
          selected={field.value}
          includeDates={props.dateOptions}
          className={`${props.className} datetime-input ${props.error ? 'error' : ''}`}
          placeholder={props.placeholder || '年月を選択'}
        />
      )}
      rules={{ required: props.required && validationRules.requiredSelect(props.label) }}
    />
  </FieldWrapper>
)

const StyledMonthComponent = styled(MonthComponent)`
  &.datetime-input {
    &.error {
      border: 1px solid ${styleTheme.colors.pink.base};
    }
  }
`